var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741:2611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.598966 8.78711C0.272208 8.78711 0.00732422 9.05203 0.00732422 9.37875V18.0685C0.00732422 18.3953 0.272247 18.6602 0.598966 18.6602H4.16354V8.78711H0.598966Z",
    fill: "#121933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9925 12.0542C19.9925 11.3031 19.5889 10.6445 18.9873 10.2838C19.2178 9.95099 19.353 9.5472 19.353 9.11255C19.353 7.97533 18.4277 7.05009 17.2905 7.05009H12.9367C13.0701 6.4454 13.2526 5.53802 13.3797 4.58813C13.7104 2.11622 13.4844 0.745316 12.6685 0.27387C12.1598 -0.0199973 11.6114 -0.0796067 11.1242 0.105862C10.7478 0.249222 10.2395 0.601683 9.94987 1.46672L8.80557 4.46286C8.22545 5.89556 6.44893 7.39966 5.34717 8.23134V18.9219C7.38912 19.6374 9.51991 20 11.6937 20H16.4377C17.575 20 18.5002 19.0748 18.5002 17.9376C18.5002 17.5393 18.3867 17.1671 18.1904 16.8515C18.878 16.5166 19.3529 15.8106 19.3529 14.9959C19.3529 14.5612 19.2177 14.1575 18.9872 13.8246C19.5889 13.4639 19.9925 12.8053 19.9925 12.0542Z",
    fill: "#121933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741:2611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.2018f742.svg";
export { ForwardRef as ReactComponent };